import React from "react";

export const IconSidebarNotification = ({
  width = 24,
  height = 24,
  color = "#302571",
  ...props
}) => (
  // <svg
  //   width={width}
  //   height={height}
  //   viewBox="0 0 24 24"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <path
  //     d="M16.666 13.782L16 13.186V8C16 6.93913 15.5786 5.92172 14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4C10.9391 4 9.92172 4.42143 9.17158 5.17157C8.42143 5.92172 8.00001 6.93913 8.00001 8V13.186L7.33401 13.782C6.36755 14.6445 5.65987 15.7586 5.29001 17H18.71C18.3401 15.7586 17.6325 14.6445 16.666 13.782ZM15 19C15 19.7956 14.6839 20.5587 14.1213 21.1213C13.5587 21.6839 12.7957 22 12 22C11.2044 22 10.4413 21.6839 9.87868 21.1213C9.31608 20.5587 9.00001 19.7956 9.00001 19H3.00001C2.99865 17.7335 3.26524 16.4811 3.78229 15.325C4.29933 14.1689 5.05512 13.1353 6.00001 12.292V8C6.00001 6.4087 6.63215 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8V12.292C18.9449 13.1353 19.7007 14.1689 20.2177 15.325C20.7348 16.4811 21.0014 17.7335 21 19H15ZM12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19H11C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20Z"
  //     fill={color}
  //   />
  // </svg>

  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 5.5C9 6.05228 9.44772 6.5 10 6.5H14C14.5523 6.5 15 6.05228 15 5.5V4.5C15 2.84315 13.6569 1.5 12 1.5C10.3431 1.5 9 2.84315 9 4.5V5.5ZM11 4.5C11 3.94772 11.4477 3.5 12 3.5C12.5523 3.5 13 3.94772 13 4.5H11ZM8 18.5C8 17.9477 8.44772 17.5 9 17.5H15C15.5523 17.5 16 17.9477 16 18.5V19.5C16 21.1569 14.6569 22.5 13 22.5H11C9.34315 22.5 8 21.1569 8 19.5V18.5ZM10 19.5C10 20.0523 10.4477 20.5 11 20.5H13C13.5523 20.5 14 20.0523 14 19.5H10Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.39404 8.55577C5.84677 6.20157 7.90673 4.5 10.3041 4.5H13.6959C16.0933 4.5 18.1532 6.20156 18.606 8.55576L20.482 18.3112C20.5383 18.6041 20.461 18.9069 20.271 19.1368C20.081 19.3668 19.7983 19.5 19.5 19.5H4.50001C4.20171 19.5 3.91899 19.3668 3.72902 19.1368C3.53905 18.9069 3.46167 18.6041 3.518 18.3112L5.39404 8.55577ZM10.3041 6.5C8.86567 6.5 7.62969 7.52094 7.35805 8.93346L5.71064 17.5H18.2894L16.642 8.93346C16.3703 7.52094 15.1343 6.5 13.6959 6.5H10.3041Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 19.5H2V17.5H22V19.5Z"
      fill={color}
    />
  </svg>
);
